export class IncompleteOrderFormError extends Error {
  public constructor() {
    super('Please review the form to complete your order.');
  }
}
